import Image from 'next/image';
import Link from 'next/link';
import ImageGroup from '../../assets/blog-register-banner-image.png';
import { Routes } from '../../util/routes';
import { CommunityRegisterButton } from '../CommunityRegisterButton';

export const BlogRegister = () => {
  return (
    <div className="relative flex flex-col items-center justify-center bg-white py-12">
      <div className="absolute -top-12 left-0 h-12 w-full bg-gradient-to-b from-transparent via-white/70 to-white"></div>

      <Image src={ImageGroup} alt="banner icon" />

      <h3 className="h3 text-brand-secondary mb-2">
        Join community and continue reading
      </h3>

      <p className="p-large mb-10 text-center font-normal">
        Gain free access to all of the contractors guidebooks, blog articles and
        jobs.
        <br />
        <Link
          href={Routes.community()}
          className="text-brand-primary hover:underline"
        >
          Learn more
        </Link>
        .
      </p>

      <CommunityRegisterButton label="Unlock access now" />
    </div>
  );
};
